import { Box, Stack } from '@mui/material'
import { preview } from '@/components/form/preview'

import { useTexts } from './hooks/useTexts'
import { BulkViewData } from '../../hooks/useBulkViewData/types'

type Props = {
  bulkData: BulkViewData
}

export function TimeWindows(props: Props) {
  const {
    bulkData: { timeWindows },
  } = props

  const texts = useTexts()

  return (
    <preview.Field label={texts.timeWindows.label}>
      {timeWindows === 'mixed' ? (
        <preview.MixValue />
      ) : timeWindows.length === 0 ? (
        <preview.NullValue />
      ) : (
        <Stack spacing={1}>
          {timeWindows.map((tw, index) => (
            <Box key={`tw_${index}`}>
              <preview.TimeWindow tw={tw} />
            </Box>
          ))}
        </Stack>
      )}
    </preview.Field>
  )
}
